// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SellForm_wrapper__P8lL9","sell-form":"SellForm_sell-form__J3I2i","submit-wrapper":"SellForm_submit-wrapper___AieT","form-result":"SellForm_form-result___bv8q"};